// extracted by mini-css-extract-plugin
module.exports = {"navBtn":"index-navBtn-1EcZF","active":"index-active-byTKh"};